import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { CheckmarkLoaderModule } from '@commons/contact-modal/checkmark-loader/checkmark-loader.component';
import { ContactModalComponent } from '@commons/contact-modal/contact-modal.component';
import { FormRgpdInfoModule } from '@commons/form-rgpd-info/form-rgpd-info.component';

@NgModule({
  imports: [
    CheckmarkLoaderModule,
    CommonModule,
    FormRgpdInfoModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  exports: [ContactModalComponent],
  declarations: [ContactModalComponent],
  entryComponents: [ContactModalComponent],
})
export class ContactModalModule {}
